import {
    TOKEN_KEY,
} from "@/AppConstants";

const parseSessionValue = (key, value, fallback = null) => {
    if (!value || value === "null" || value === "undefined") {
        return fallback;
    }
    if (key === TOKEN_KEY) {
        return value;
    }

    try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`Failed to parse sessionStorage value ${key}: ${value}:`, error);
        return fallback;
    }
};

export const clearSession = () => {
    sessionStorage.clear();
};

export const getSessionItem = (key) => {
    const value = sessionStorage.getItem(key);
    return parseSessionValue(key, value);
};

export const setSessionItem = (key, value) => {
    if (value === null || value === undefined) {
        sessionStorage.removeItem(key);
    } else if (typeof value === "string") {
        // Store strings directly without JSON.stringify to avoid adding quotes
        sessionStorage.setItem(key, value);
    } else {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
};

export const removeSessionItem = (key) => {
    sessionStorage.removeItem(key);
};
